import {Injectable}     from 'angular2/core';
import {Language} from "../../models/language.model";

@Injectable()
export class LanguageService {

    constructor() {
    }

    getLanguages():Language[] {
        //For the moment, as specifications describe, there are only 2 supported locale
        return [
            new Language({name: "Français", iso: "FR"}),
            new Language({name: "English", iso: "EN"})
        ];
    }
}